import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=1bd1b1a4&scoped=true"
import script from "./Iframe.vue?vue&type=script&lang=ts"
export * from "./Iframe.vue?vue&type=script&lang=ts"
import style0 from "./Iframe.vue?vue&type=style&index=0&id=1bd1b1a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd1b1a4",
  null
  
)

export default component.exports